var React = require('react');

function BlockIconLog (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.35744 9.66804C8.62182 10.1919 7.72189 10.5 6.75 10.5C4.26472 10.5 2.25 8.48528 2.25 6C2.25 5.02811 2.5581 4.12818 3.08196 3.39256L9.35744 9.66804ZM10.4181 8.60736L4.14263 2.33191C4.87824 1.80808 5.77814 1.5 6.75 1.5C9.23528 1.5 11.25 3.51472 11.25 6C11.25 6.97186 10.9419 7.87176 10.4181 8.60736ZM12.75 6C12.75 9.31371 10.0637 12 6.75 12C3.43629 12 0.75 9.31371 0.75 6C0.75 2.68629 3.43629 0 6.75 0C10.0637 0 12.75 2.68629 12.75 6Z","fill":"black"}));
}

BlockIconLog.defaultProps = {"width":"13","height":"12","viewBox":"0 0 13 12","fill":"none"};

module.exports = BlockIconLog;

BlockIconLog.default = BlockIconLog;
